import { useModal } from "../../hooks/useModalHook";
import styles from "./ModalPDF.module.css";

const ModalPDF = ({ src }) => {
  console.log(src)
  const { closeModal } = useModal();
  return (
    <div className={styles.modal}>
      <object
        data={src}
        type="application/pdf"
        className={styles.pdfObject}
      >
        Ваш браузер не поддерживает просмотр PDF.
        <a href={src} target="_blank" rel="noreferrer">
          Скачать PDF
        </a>
      </object>
    </div>
  );
};


export default ModalPDF;